/**
 * Prince Tires – Wheel spec parser
 * Normalizes bolt pattern (5x114.3, 5X114.3, 5 114.3, 5-114.3) and builds wheel tags.
 * Tag convention: products use separate tags — e.g. "16", "5x114.3" (diameter and bolt pattern as plain tags).
 */
(function(global) {
  'use strict';

  /**
   * Normalize bolt pattern input to canonical "NxPCD" (e.g. 5x114.3).
   * @param {string} input - e.g. "5x114.3", "5 114.3", "5-114.3"
   * @returns {{ ok: boolean, canonical?: string, error?: string }}
   */
  function normalizeBoltPattern(input) {
    var result = { ok: false };
    if (typeof input !== 'string') {
      result.error = 'Enter bolt pattern (e.g. 5x114.3)';
      return result;
    }
    var raw = input.trim().replace(/\s*[xX\-]\s*/g, 'x').replace(/\s+/g, 'x');
    var match = raw.match(/^(\d)x([\d.]+)$/);
    if (!match) {
      result.error = 'Use format: 5x114.3 or 5 114.3';
      return result;
    }
    var studs = parseInt(match[1], 10);
    var pcd = parseFloat(match[2]);
    if (studs < 3 || studs > 8 || pcd < 90 || pcd > 160) {
      result.error = 'Bolt pattern should be e.g. 5x114.3';
      return result;
    }
    result.ok = true;
    result.canonical = studs + 'x' + pcd;
    return result;
  }

  /**
   * Build wheel tag handle for single-tag URL (e.g. 5x114.3 -> 5x114-3).
   */
  function wheelTagToHandle(tag) {
    return String(tag).toLowerCase().replace(/\./g, '-').replace(/\s+/g, '-');
  }

  /**
   * Build wheel search tags from inputs. Products should have these as separate tags.
   * - Diameter: "16"
   * - Width (optional): "7"
   * - Bolt pattern: "5x114.3"
 * - Center bore (optional): "67.1" or "CB:67.1"
 * @param {{ diameter?: number, width?: number, boltPattern?: string, centerBore?: string|number }} spec
   * @returns {string[]} Tag strings (products must have ALL these tags)
   */
  function buildWheelTags(spec) {
    var tags = [];
    if (spec.diameter != null) {
      tags.push(String(spec.diameter));
    }
    if (spec.width != null) {
      tags.push(String(spec.width));
    }
    if (spec.boltPattern) {
      var bp = normalizeBoltPattern(spec.boltPattern);
      if (bp.ok) tags.push(bp.canonical);
    }
    if (spec.centerBore != null && String(spec.centerBore).trim() !== '') {
      var cbRaw = String(spec.centerBore).trim();
      var cbNumeric = cbRaw.replace(/^CB[:\s-]*/i, '');
      tags.push(cbNumeric);
      tags.push('CB:' + cbNumeric);
    }
    return tags;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeBoltPattern: normalizeBoltPattern, wheelTagToHandle: wheelTagToHandle, buildWheelTags: buildWheelTags };
  } else {
    global.PrinceTires = global.PrinceTires || {};
    global.PrinceTires.normalizeBoltPattern = normalizeBoltPattern;
    global.PrinceTires.wheelTagToHandle = wheelTagToHandle;
    global.PrinceTires.buildWheelTags = buildWheelTags;
  }
})(typeof window !== 'undefined' ? window : this);
